import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ServiceAdminListQuery } from '@upme/contracts';

export const Route = createFileRoute('/_authenticated/services')({
  staticData: { breadcrumb: 'Услуги' },
  validateSearch: ServiceAdminListQuery.catch(ServiceAdminListQuery.parse({ status: 'PENDING_MODERATION' })),
  component: () => <Outlet />,
});
